import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { ActionsService } from '../../services';
import { FormatHelper } from '../../helpers';
import ActionForm from './action_form';

@connect(state => {
  return {
    me: state.user.me
  }
})
class ActionEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      action: null,
      actionId: props.match.params.actionId,
      actionToEdit: null
    };
  }

  componentDidMount() {
    ActionsService.get(this.state.actionId).then(response => {
      this.setState({ actionToEdit: response.action });
    }).catch(error => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-action-edit') });
      console.error(error);
    });
    ActionsService.getAssociatedAlertConfigs(this.state.actionId).then(response => {
      this.setState({ alertConfigurations: response.alertConfigurations });
    }).catch(error => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-alert-configs') });
      console.error(error);
    });
  }

  handleSubmit({ name, description, actionResults }) {
    // TODO drop actionResults without complete info

    const translatedActionResults = actionResults.map(actionResult => {
      if (actionResult.type.actionResultType.isRoleBased) {
        return ({
          id: actionResult.id,
          role: { id: actionResult.value.value },
          actionResultType: { id: actionResult.type.actionResultType.id }
        });
      } else if (actionResult.locale) {
        return ({
          id: actionResult.id,
          value: actionResult.type.actionResultType.token === 'ad_hoc_sms' ? FormatHelper.formatPhoneNumber(actionResult.value) : actionResult.value,
          actionResultType: { id: actionResult.type.actionResultType.id },
          locale: actionResult.locale.value
        });
      } else {
        
        return ({
          id: actionResult.id,
          value: actionResult.value,
          actionResultType: { id: actionResult.type.actionResultType.id }
        })
      }
    });

    const action = {
      id: this.state.actionToEdit.id,
      enterprise: { id: this.props.me.enterprise.id },
      name: name,
      description: description,
      actionResults: translatedActionResults
    };

    ActionsService.save(action).then(response => {
      this.setState({ action: response.action });
    }).catch(error => {
      console.error(error); // TODO handle error
    });
  }

  render() {
    if (this.state.action) {
      return (
          <Redirect to={{
            pathname: '/config/actions',
            state: {
              successMessage: 'Action saved'
            }
          }}/>
      );
    } else if(this.props.me && this.state.actionToEdit && this.state.alertConfigurations) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
        <div>
          <div className="row">
            <PageTitle 
              title={i18next.t('pages.actions.edit-action')}
              backLinkWithParams={{
                link: {
                  pathname: "/config/actions",
                  search: backLinkSearch
                }
              }} 
            />
          </div>
          <ActionForm
            action={this.state.actionToEdit}
            alertConfigurations = {this.state.alertConfigurations}
            onSubmit={this.handleSubmit.bind(this)}
            backLinkWithParams={{
              link: {
                pathname: "/config/actions",
                search: backLinkSearch
              }
            }}
          />
        </div>
      );
    } else {
      return (
        <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }
}

export default ActionEdit;
